import { translate } from '../../helpers/stringHelpers'

export function parseJsonContent (str) {
  if (!str) return ''

  if (!str.includes('%7B')) {
    return str
  }

  const htmlTagPattern = /^<[^>]+>(.*)<\/[^>]+>$/
  const match = str.match(htmlTagPattern)
  if (match) {
    str = match[1]
  }

  str = str.replace(/%7B/g, '{').replace(/%7D/g, '}').replace('[lt]', '<').replace('[gt]', '>') // .replace(/\\\//g, '/')
  let parseJsonContent
  try {
    parseJsonContent = JSON.parse(str)
  } catch (error) {
    console.warn('Failed to parse JSON:', error)
    return ''
  }
  return parseJsonContent
}

export function getLotNumberString (listingType, isMarketplace = false) {
  if (isMarketplace) return 'ItemCodes_MARKETPLACE_DISPLAY_VALUE'
  if (listingType === 'listing') return 'ItemCodes_LISTING_DISPLAY_VALUE'
  return 'ItemCodes_LOT_DISPLAY_VALUE'
}

export function getLotTitle (listing) {
  const lotNumber = listing.isMarketplace ? listing.id : listing.lotNumber
  if (listing.title.includes('::ITEM_INFORMATION_TITLE')) {
    listing.title = listing?.specs?.name || 'Untitled'
  }
  return `${translate(getLotNumberString(listing.type, listing?.isMarketplace))} ${lotNumber} - ${listing.title}`
}
